import { createApp } from 'vue';
import i18n from '@/utils/i18n'
import { useI18n } from 'vue-i18n';
import "@/utils/rem.js";
import 'ant-design-vue/dist/antd.css';
import antd from 'ant-design-vue';
import "@/assets/style/common.less";
import "@/assets/style/changeAnt.less";
import App from './App.vue';
import router from './router';
import store from './store';
import 'default-passive-events'

import SvgIcon from '@/components/svg-icon/index.vue';
import BackTop from '@/components/backTop.vue';
import MyLoading from '@/components/loading.vue';
import pageTit from '@/components/pagetit.vue';
import EaSearch from '@/components/searchs.vue';

import whiteList from "./utils/whiteList";
// import filterXSS from "xss"
const xss = require("xss");

const myXss = new xss.FilterXSS({ whiteList, css: false });

const app = createApp(App);

app.use(i18n).use(antd).use(store).use(router).mount('#app');
app.component('svg-icon', SvgIcon);
app.component('back-top', BackTop) // 注册全局组件
app.component('my-loading', MyLoading) // 注册全局组件
app.component('page-tit', pageTit) // 注册全局组件
app.component('ea-search', EaSearch) // 注册全局组件
app.config.globalProperties.$xss = myXss;
app.config.globalProperties.$et = (word, options) => {
  const { t } = useI18n();
  return t(word ? word.replace(/\s*/g, "").toLowerCase() : '', options)
}

app.directive('InfiniteLoading', {
  mounted(el, binding) {
    const cb = binding.value;
    el.addEventListener('scroll', async (e) => {
      const scrollTop = el.scrollTop
      const windowHeight = el.clientHeight || document.body.clientHeight
      const scrollHeight = el.scrollHeight
      const value = el.getAttribute(`disabled`);
      const disabled = value === 'false' ? false : Boolean(value)
      // 滚动条到底部

      if ((scrollTop + (windowHeight + 10) >= scrollHeight) && !disabled) {
        await cb && cb();
      }
    })
  }
})